<script setup>
import { useScrollStore } from "@/stores/storeScroll";
import { RouterLink } from "vue-router";

const storeScroll = useScrollStore();
</script>
<template>
	<section class="not-page" :style="{ paddingTop: storeScroll.paddingTop }">
		<div class="container --big">
			<div class="not-page__container">
				<div class="not-page__content">
					<h1 class="not-page__title">Страница, которую Вы ищете, не найдена.</h1>
					<div class="not-page__info">
						<p class="not-page__subtitle">Что можно сделать?</p>
						<ul class="not-page__list">
							<li>Проверьте адрес страницы — возможно, в нем закралась ошибка.</li>
							<li>Вернитесь на главную страницу и начните заново.</li>
						</ul>
					</div>
					<RouterLink to="/" class="not-page__btn btn">На главную</RouterLink>
				</div>
				<div class="not-page__numbers">
					<span class="not-page__number">4</span>
					<img class="not-page__teapot" width="169" height="166" src="@/assets/img/404/teapot.webp" alt="чайник" />
					<span class="not-page__number">4</span>
				</div>
			</div>
		</div>
	</section>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.not-page {
	position: relative;
	min-height: 75.7rem;
	display: flex;
	flex-direction: column;
	background-color: #0f2e1b;
	box-shadow: 0 4.4rem 10rem 0 rgba(0, 0, 0, 0.25);
	overflow: hidden;
	background-image: url("@/assets/img/404/bg_pattern_2.webp");
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;

	&::before {
		content: "";
		position: absolute;
		inset: 0;
		box-shadow: inset 0 0 11.39rem 0 rgba(0, 0, 0, 0.64);
		pointer-events: none;
		z-index: 1;
	}

	// &::after {
	// 	content: "";
	// 	position: absolute;
	// 	inset: 0;
	// 	background-image: url("@/assets/img/404/bg_pattern.webp");
	// 	background-repeat: no-repeat;
	// 	background-position: center;
	// 	background-size: cover;
	// 	mix-blend-mode: multiply;
	// 	opacity: 0.67;
	// 	pointer-events: none;
	// }

	@media (max-width: vars.$t) {
		min-height: 60rem;
	}

	@media (max-width: vars.$x480) {
		min-height: auto;
		padding-bottom: 4rem;
	}
	.container {
		width: 100%;
	}
	&__container {
		position: relative;
		z-index: 2;
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		margin: 0 auto;
		padding: 12rem 24rem 5rem 16rem;
		flex: 1;

		@media (max-width: vars.$l) {
			padding: 0 4rem;
			padding: 10rem 0rem 0rem;
		}

		@media (max-width: vars.$t) {
			flex-direction: column-reverse;
			justify-content: center;
			gap: 4rem;
			padding: 2rem 0rem 4rem;
		}

		@media (max-width: vars.$x480) {
			gap: 3rem;
			// padding: 3rem var(--padding-container);
		}
	}

	&__content {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 3.2rem;
		max-width: 74.1rem;

		@media (max-width: vars.$t) {
			align-items: center;
			text-align: center;
			max-width: 100%;
		}

		@media (max-width: vars.$x480) {
			gap: 2.4rem;
		}
	}

	&__title {
		font-family: var(--second-family);
		font-weight: 700;
		font-size: 2.4rem;
		line-height: 110%;
		text-transform: uppercase;
		color: var(--text-inverse-100);

		@media (max-width: vars.$x480) {
			font-size: 1.8rem;
		}
	}

	&__info {
		display: flex;
		flex-direction: column;
		gap: 1.6rem;

		@media (max-width: vars.$t) {
			align-items: center;
		}
	}

	&__subtitle {
		font-family: var(--font-family);
		font-weight: 700;
		font-size: 2rem;
		line-height: 120%;
		color: var(--text-accent-2-100);

		@media (max-width: vars.$x480) {
			font-size: 1.6rem;
		}
	}

	&__list {
		display: flex;
		flex-direction: column;
		gap: 0;
		list-style: disc;
		padding-left: 3rem;
		font-family: var(--font-family);
		font-weight: 500;
		font-size: 2rem;
		line-height: 120%;
		color: var(--text-inverse-100);

		@media (max-width: vars.$t) {
			text-align: left;
		}

		@media (max-width: vars.$x480) {
			font-size: 1.6rem;
			padding-left: 2rem;
		}

		li {
			margin-bottom: 0;
		}
	}

	&__btn {
		min-width: 26.7rem;

		@media (max-width: vars.$x480) {
			min-width: 100%;
		}
	}

	&__numbers {
		display: flex;
		align-items: center;
		gap: 1.6rem;

		@media (max-width: vars.$x480) {
			gap: 1rem;
		}
	}

	&__number {
		font-family: var(--second-family);
		font-weight: 700;
		font-size: 20rem;
		line-height: 110%;
		text-transform: uppercase;
		color: var(--text-accent-2-100);

		@media (max-width: vars.$l) {
			font-size: 16rem;
		}

		@media (max-width: vars.$t) {
			font-size: 12rem;
		}

		@media (max-width: vars.$x480) {
			font-size: 8rem;
		}
	}

	&__teapot {
		width: 16.9rem;
		height: auto;
		object-fit: contain;

		@media (max-width: vars.$l) {
			width: 13rem;
		}

		@media (max-width: vars.$t) {
			width: 10rem;
		}

		@media (max-width: vars.$x480) {
			width: 7rem;
		}
	}
}
</style>
